module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"unit":{"businessHours":"businessHours","day":"day","week":"week","month":"month","year":"year"}},"zh-tw":{"unit":{"businessHours":"營業時段","day":"日","week":"週","month":"月","year":"年"}}}')
  delete Component.options._Ctor
}
